import { Document, Page, type PageProps } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import type { Quote } from '@core/types/api/Quote/Quote';

import { CityTransitMixSigningArea } from '../../components/SigningArea';

const pageStyle: PageProps['style'] = {
  padding: '0.5in',
};

type CityTransitMixDefaultSigningSectionProps = {
  quote: Quote;
  // locale is passed from TemplateByName but not used in this signing section
  // eslint-disable-next-line react/no-unused-prop-types
  locale: string;
};

export const CityTransitMixDefaultSigningSection = ({
  quote,
}: CityTransitMixDefaultSigningSectionProps): ReactElement => (
  <Document title={quote.quoteNumber}>
    <Page style={pageStyle}>
      <CityTransitMixSigningArea quote={quote} />
    </Page>
  </Document>
);
